import { createContext } from "react";

export const ModalLabelContext = createContext("");
